import { shallowRef, ref } from 'vue';
import { defineStore } from 'pinia';

export default defineStore('selectedPlanStore', () => {
  // State
  const selectedPlanIdHistory = shallowRef<Record<number, number | null>>({});
  const selectedPlanId = ref<number | null>(null);
  const planType = ref<string>('');

  // Actions
  function updateSelectedPlanIdByUpc(upcNumber: UpcId | undefined) {
    selectedPlanId.value = (upcNumber && selectedPlanIdHistory.value?.[upcNumber as number]) || null;
  }

  function updateSelectedPlanIdByForm(planId: number) {
    selectedPlanId.value = planId >= 0 ? planId : -Infinity;
  }

  // Persist selected plan ID for the current UPC
  function updatePlanIdEntryByUpc(selectedUpcId: number) {
    selectedPlanIdHistory.value[selectedUpcId] = selectedPlanId.value;
  }

  function includePlanInATBPayload(): { optedProtectionPlanId?: number } {
    const _selectedPlanId = selectedPlanId.value;
    if (_selectedPlanId === -Infinity || _selectedPlanId === null) {
      return {};
    }
    return {
      optedProtectionPlanId: _selectedPlanId,
    };
  }

  return {
    // State
    selectedPlanIdHistory,
    selectedPlanId,
    planType,

    // Actions
    updateSelectedPlanIdByUpc,
    updateSelectedPlanIdByForm,
    updatePlanIdEntryByUpc,
    includePlanInATBPayload,
  };
});
